// extracted by mini-css-extract-plugin
export default {"cart":"cart_cart__CtT40","text":"cart_text__Rj6g0"};